import React from 'react';

export default function AlertBox({
  children,
  primary,
  warning,
  success,
  danger,
}) {
  return primary ? (
    <div className="alert alert-primary mt-3" role="alert">
      {children}
    </div>
  ) : success ? (
    <div className="alert alert-success mt-3" role="alert">
      {children}
    </div>
  ) : danger ? (
    <div className="alert alert-danger mt-3" role="alert">
      {children}
    </div>
  ) : warning ? (
    <div className="alert alert-warning mt-3" role="alert">
      {children}
    </div>
  ) : (
    <div className="alert alert-primary mt-3" role="alert">
      {children}
    </div>
  );
}
